// removed by extract-text-webpack-plugin
module.exports = {"trips-container":"_27tTb2rc8l5BrBw5bzE4dh","line":"mLG5Pjwj7BYYizN6iOC69"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LocalExpertProfile/LocalExpertTrips.scss
// module id = 1189
// module chunks = 2